import React from "react";
import { compose } from "recompose";
import { FormattedMessage } from "react-intl";

import { setTitleOnPage } from "@app/util";
import { messages } from "@app/messages";
import { messages as dMessages } from "@deliveries/messages";
import { DeliveriesList } from "@deliveries/components/DeliveriesList";
import { Page, PageTitle } from "@ui/Page";

const breadcrumbItems = [
    {
        text: <FormattedMessage {...messages.pageDeliveriesTitle} />,
    },
];

const DeliveriesIndex = () => (
    <Page className="deliveries-index-page" breadcrumbs={breadcrumbItems}>
        <PageTitle tag="h1" className="display-2">
            <FormattedMessage {...dMessages.deliveryEntityPlural} />
        </PageTitle>
        <p className="sub-heading">
            <FormattedMessage {...messages.pageDeliveriesIntro} />
        </p>
        <DeliveriesList />
    </Page>
);

const ConnectedDeliveriesIndex = compose(
    setTitleOnPage(messages.pageDeliveriesTitle),
)(DeliveriesIndex);

export {
    DeliveriesIndex as DeliveriesIndexPresenter,
    ConnectedDeliveriesIndex as DeliveriesIndex,
};
